import React, { useState, useEffect } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Table from "../../TableComponent";

const Facilitator = ({adminInfo}) => {
  const [loading, setLoading] = useState(true)
  const [facilitatorData, setFacilitatorData] = useState([])
  const [lang, setLang] = useState(adminInfo.test.lang.sort()[0]);
  const [region, setRegion] = useState("");
  const [schoolName, setschoolName] = useState("");
  
  const { t } = useTranslation();
  
  useEffect(() => {
    if(adminInfo.test){

      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        
        const getFacilitatorData = async(testId, adminId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/facilitator?testId="+testId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log("Facilitator Data: ",response.data)
            setFacilitatorData(response.data["facilitator"])
            setLoading(false)
          }
          catch (error) {
            console.log(error)
            setLoading(false)
          }
        }
        
        getFacilitatorData(adminInfo.test ? adminInfo.test.testId : null, adminInfo.admin.adminId)
        
      })
      .catch((err) => console.log(err));
    }
    else alert("Test has not started yet")
    
  }, [adminInfo]);
  
  const columns = [
    {
      key: "fullName",
      headerName: t("commonItems.tableHeader_facilitator"),
      width: 80
    },
    {
      key: "schoolName",
      headerName: t("commonItems.tableHeader_school"),
      width: 80
    },
    { 
      key: "shift", 
      headerName: t("commonItems.tableHeader_shift"), 
      width: 20 
    },
    { 
      key: "region", 
      headerName: t("commonItems.tableHeader_region"), 
      width: 60 
    },
    // { 
    //   key: "class", 
    //   headerName: "Class", 
    //   width: 20 
    // },
    // { 
    //   key: "section", 
    //   headerName: "Section", 
    //   width: 20 
    // },
    { 
      key: "classSection", 
      headerName: t("commonItems.tableHeader_classSection"), 
      width: 20 
    },
    { 
      key: "studentCount", 
      headerName: t("commonItems.tableHeader_studentsCount"), 
      width: 40 
    },
    // {
    //   key: "recCount",
    //   headerName: "Students Tested Count - " + adminInfo.allLangs[lang],
    //   width: 40
    // },
    {
      key: "recPercent",
      headerName: t("commonItems.tableHeader_studentsTested") + " - " + adminInfo.allLangs[lang] + " (%)",
      width: 80,
      percent: true
    }
  ];

  // if(adminInfo?.test?.status === 3) columns.push({
  //   key: "viewPercent",
  //   headerName: "Intervention Material Viewed " + adminInfo.allLangs[lang] + " (%)",
  //   width: 40,
  //   percent: true
  // })

  const headers = [
    { label: "Facilitator Name", key: "fullName" },
    { label: "School Name", key: "schoolName" },
    { label: "Shift", key: "shift" },
    { label: "Region", key: "region" },
    { label: "Class", key: "class" },
    { label: "Section", key: "section" },
    { label: "Students Count", key: "studentCount" },
    { label: "Students Tested Count - " + adminInfo.allLangs[lang], key: "recCount"},
    { label: "Students Tested - " + adminInfo.allLangs[lang] + " (%)", key: "recPercent" },
    // { label: "Intervention Material File Count - " + adminInfo.allLangs[lang], key: "fileCount" },
    // { label: "Intervention Material View Count - " + adminInfo.allLangs[lang], key: "viewCount" },
    // { label: "Intervention Material Viewed - " + adminInfo.allLangs[lang] + " (%)", key: "viewPercent" }
  ];

  const handleLangChange = (e) => {
    setLang(e.target.value);
  };
  
  const handleRegionChange = (e) => {
    if (e.target.value ==="" ) setschoolName("")
    setRegion(e.target.value);
  };
  
  const handleSchoolNameChange = (e) => {
    setschoolName(e.target.value);
  };
  
  var filteredFacilitatorData
  if(region==="" || (region==="" && schoolName==="")){
    filteredFacilitatorData = facilitatorData
  }
  else if(region!=="" && schoolName===""){
    filteredFacilitatorData = [...facilitatorData.filter(item => item.region === region)]
  }
  else{
    filteredFacilitatorData = [...facilitatorData.filter(item => item.region === region && item.schoolName === schoolName)]
  }

  var counts = {
    studentCount: 0,
    ...adminInfo.test.lang.sort().reduce((acc, lang) => {
      acc[`${lang}RecCount`] = 0; // Create a key for each language with value 0
      return acc;
    }, {})
  };
  if(adminInfo && adminInfo.test) {
    let langs = adminInfo.test.lang.sort()
    counts.studentCount = filteredFacilitatorData.reduce((acc, item) => {
      return acc + item.counts[langs[0]].studentCount
    }, 0)
    
    langs.forEach(lang => {
      counts[`${lang}RecCount`] = filteredFacilitatorData.reduce((acc, item) => {
      return acc + item.counts[lang].recCount
    }, 0)
    });
  }
  // console.log(counts)
  // console.log(facilitatorData)
  // console.log(filteredFacilitatorData)

  return (
    <div className="facilitatorContent innerContent">
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("admin.facilitator.title")}{adminInfo.test ? <span> - {adminInfo.test.testName}</span>: ""}
      </h2>
      <div className="countTileContainer">
        <div className="countTile">
          <div className="countTileLeft">{t("commonItems.countTile_StudentCount")}:</div>
          <div className="countTileRight">{counts.studentCount.toLocaleString("hi")}</div>
        </div>
        {adminInfo && adminInfo.test &&
          adminInfo.test.lang.sort().map((lang, i) => {
            return <div className="countTile" key={i}>
                    <div className="countTileLeft">{t("commonItems.countTile_TestedCount")} - {adminInfo.allLangs[lang]}:</div>
                    <div className="countTileRight">{counts[`${lang}RecCount`].toLocaleString("hi")}</div>
                  </div>
          })
        }
      </div>
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="langFilterLabel">{t("commonItems.dropdownLabel_lang")}</InputLabel>
            <Select
              labelId="langFilterLabel"
              id="langFilter"
              value={lang}
              onChange={handleLangChange}
              autoWidth
              label={t("commonItems.dropdownLabel_lang")}
            >
              {adminInfo.test &&
                adminInfo.test.lang.sort().map((item, i) => {
                  return <MenuItem key={i} value={item}>{adminInfo.allLangs[item]}</MenuItem>   
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150}} size="small">
            <InputLabel id="regionFilterLabel">{t("commonItems.dropdownLabel_region")}</InputLabel>
            <Select
              labelId="regionFilterLabel"
              id="regionFilter"
              value={region}
              onChange={handleRegionChange}
              autoWidth
              label={t("commonItems.dropdownLabel_region")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique region values from data */}
              {[...new Set(facilitatorData.map(item => item.region))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
              })}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="schoolNameFilterLabel">{t("commonItems.dropdownLabel_school")}</InputLabel>
            <Select
              labelId="schoolNameFilterLabel"
              id="schoolNameFilter"
              value={schoolName}
              onChange={handleSchoolNameChange}
              autoWidth
              label={t("commonItems.dropdownLabel_school")}
            >
              {region===""? 
                <MenuItem disabled>Select Region First</MenuItem>
                :
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
              }
              {[...new Set(facilitatorData.filter(item => item.region === region).map(item => item.schoolName))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
              })}
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="tabs">
        <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
          <CSVLink 
            data={filteredFacilitatorData.map(item => {
              let counts = item.counts[lang]
              return {
                ...item,
                "fullName": item["firstName"] + " " + item["lastName"],  // adding full name by combining firstName and lastName
                "classSection": item["class"] + "-" + item["section"],
                ...counts,
                "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
                "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
              }
            })} 
            headers={headers} 
            filename={"FacilitatorData - " + adminInfo.allLangs[lang] + ".csv"}
          >
            {t("commonItems.buttonLabel_csvDownload")}
          </CSVLink>
        </Button>
      </div>
      <Divider />
      <div className="table">
        <Table
          columns={columns}
          tableData={filteredFacilitatorData.map(item => {
            let counts = item.counts[lang]
            return {
              ...item,
              "fullName": item["firstName"] + " " + item["lastName"],
              "classSection": item["class"] + "-" + item["section"],
              ...counts,
              "recPercent": counts["recCount"] ? Math.round(counts["recCount"]*100/counts["studentCount"]*100)/100 : 0, 
              "viewPercent": counts["viewCount"] ? Math.round(counts["viewCount"]*100/counts["fileCount"]*100)/100 : 0
            }
          })}
          orderBy={["recPercent", "viewPercent", "studentCount"]} 
          tableHeight="calc(100vh - 390px)"
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Facilitator;
